import { Button, createStyles, withStyles } from '@material-ui/core';
var style = createStyles({
  root: {
    backgroundColor: '#f4cc6f',
    '&:hover': {
      backgroundColor: '#e3be68'
    },
    '&:active': {
      backgroundColor: '#fbd370'
    },
    '&:disabled': {
      color: 'rgba(0, 0, 0, 0.26)',
      backgroundColor: 'rgba(0, 0, 0, 0.12)'
    }
  }
});
export default withStyles(style, {
  name: 'WarningButton'
})(Button);